import Paper from '@mui/material/Paper'
import TableContainer from '@mui/material/TableContainer'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableRow from '@mui/material/TableRow'
import TableCell from '@mui/material/TableCell'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import { SxProps, Theme } from '@mui/material/styles'
import { formattedAmount } from '@/utils/stripeUtils'

export interface HourlyFeeQuoteProps {
  hourlyRate: number
  payableAmount: number
  discount: number
  discountTotal: number
  subtotal: number
  total: number
  details: string
  sx: SxProps<Theme>
}

const HourlyFeeQuote = ({
  hourlyRate,
  payableAmount,
  discount,
  discountTotal,
  subtotal,
  total,
  details,
  sx = {},
}: HourlyFeeQuoteProps) => {
  return (
    <Grid>
      <TableContainer component={Paper} sx={sx}>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell colSpan={2} sx={{ backgroundColor: '#f5f5f5' }}>
                <Typography
                  variant="caption"
                  data-testid="quoteDetails-description"
                >
                  {details}
                </Typography>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography variant="caption">
                  Attorney's Standard Hourly Rate:{' '}
                </Typography>
              </TableCell>
              <TableCell align="right">
                <Typography variant="caption" data-testid="hourlyRate">
                  ${formattedAmount(hourlyRate)}/hour
                </Typography>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography variant="caption">
                  LegalFix Member Discount ({discount * 100}%):
                </Typography>
              </TableCell>
              <TableCell align="right">
                <Typography variant="caption" data-testid="discount">
                  ${formattedAmount(discountTotal)}
                  /hour
                </Typography>
              </TableCell>
            </TableRow>
            {discount !== 0 && (
              <TableRow>
                <TableCell>
                  <Typography variant="caption">
                    Attorney's Discounted Hourly Rate:
                  </Typography>
                </TableCell>
                <TableCell align="right">
                  <Typography variant="caption" data-testid="subtotal">
                    ${formattedAmount(subtotal)}/hour
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <TableContainer component={Paper} sx={sx}>
        <Table>
          <TableRow>
            <TableCell>
              <Typography variant="h3">
                Fee Deposit/Security Retainer Required:
              </Typography>
            </TableCell>
            <TableCell>
              <Typography
                variant="subtitle1"
                align="right"
                aria-label="Quote total"
                color="#000"
                data-testid="total"
              >
                ${formattedAmount(total)}
              </Typography>
            </TableCell>
          </TableRow>
        </Table>
      </TableContainer>
    </Grid>
  )
}
export default HourlyFeeQuote
